// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38qdW","newExpiryDate":"styles_newExpiryDate__2f8vG","footer":"styles_footer__1bffD"};